var exports = {
  "i": "xaee3c4fa--40976b--wrapper",
};

module.exports = exports;
